import { render } from "./VTableAuxiliaryFastForm.vue?vue&type=template&id=b2a00f1e"
import script from "./VTableAuxiliaryFastForm.vue?vue&type=script&lang=js"
export * from "./VTableAuxiliaryFastForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__